import React from "react";
import RXJS from "rxjs";
import { subscribeToContextChange } from "@platform/core";
import { WorkItem } from "../../models/WorkItem";
import { getWorkItem } from "../../utils/storage";
import { TitleCard } from "@platform/style";
import { ActivityRecordPage } from "../../models/ActivityRecordPage";
import { useGetWithToken } from "../../utils/useGetWithToken";
import { RenderHistory } from "./RenderHistory";

let workItemSubscription: RXJS.Subscription;

export const ShowWorkItemHistory = () => {
  const [currentWorkItem, setCurrentWorkItem] = React.useState<WorkItem | undefined>(getWorkItem());

  React.useEffect(() => {
    workItemSubscription = subscribeToContextChange("workItem", {
      onSet: () => {
        setCurrentWorkItem(getWorkItem());
      },
      onUnset: () => {
        setCurrentWorkItem(getWorkItem());
      },
    });
    return () => {
      workItemSubscription.unsubscribe();
    };
  }, []);

  React.useEffect(() => {
    window.addEventListener("updateWorkItem", statusUpdate);
    return () => {
      window.removeEventListener("updateWorkItem", statusUpdate);
    };
  }, []);

  function statusUpdate() {
    setCurrentWorkItem(getWorkItem());
  }

  const [data, _isLoading, isErrored, refetch, errorStack, correlationId] =
    useGetWithToken<ActivityRecordPage | null>(currentWorkItem, null);

  return currentWorkItem && (data || isErrored) ? (
    <TitleCard
      id={"workItemHistoryPanel"}
      title={"Work Item History"}
      titleCardScreenPosition={{ topMarginInPx: "16px" }}
    >
      <RenderHistory
        data={data}
        refetch={refetch}
        correlationId={correlationId}
        isErrored={isErrored}
        errorStack={errorStack}
      />
    </TitleCard>
  ) : null;
};
